import { CustomIconProps } from './art';

export const LungsVirusIcon = ({ fill }: CustomIconProps): JSX.Element => (
  <svg width="30" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M16.125 7.063V.75a.75.75 0 0 0-.75-.75h-.75a.75.75 0 0 0-.75.75v6.313a2.177 2.177 0 0 1 2.25 0Zm-6.96 13.771a2.253 2.253 0 0 1 0-3.182l.403-.402H9a2.25 2.25 0 0 1 0-4.5h.568l-.403-.402A2.25 2.25 0 0 1 12 8.88V7.582C12 5.877 10.528 4.5 8.717 4.5 6.656 4.5 6 5.836 4.963 7.46A38.415 38.415 0 0 0 .18 18.286C.06 18.74 0 19.207 0 19.676c0 2.87 2.93 4.946 5.87 4.154l2.79-.744a4.618 4.618 0 0 0 2.46-1.628 2.179 2.179 0 0 1-1.955-.624Zm10.608-1.06a.75.75 0 0 0 0-1.061l-.402-.402c-.945-.945-.276-2.561 1.06-2.561H21a.75.75 0 1 0 0-1.5h-.569c-1.336 0-2.005-1.616-1.06-2.56l.402-.402a.75.75 0 1 0-1.061-1.061l-.402.402c-.945.945-2.56.276-2.56-1.06V9a.75.75 0 1 0-1.5 0v.568c0 1.337-1.616 2.006-2.561 1.06l-.402-.401a.75.75 0 0 0-1.06 1.06l.401.403c.945.944.276 2.56-1.06 2.56H9a.75.75 0 1 0 0 1.5h.568c1.336 0 2.005 1.616 1.06 2.56l-.402.403a.749.749 0 0 0 .818 1.227.749.749 0 0 0 .243-.167l.402-.401c.945-.945 2.56-.276 2.56 1.06V21a.75.75 0 1 0 1.5 0v-.568c0-1.336 1.616-2.005 2.561-1.06l.402.401a.752.752 0 0 0 1.06 0Zm-6.274-5.524a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm3 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm13.319 1.037A38.413 38.413 0 0 0 25.036 7.46C24 5.836 23.343 4.5 21.281 4.5 19.47 4.5 18 5.877 18 7.582v1.3a2.25 2.25 0 0 1 2.834 3.468l-.403.4H21a2.25 2.25 0 1 1 0 4.5h-.569l.403.402a2.236 2.236 0 0 1-1.956 3.805 4.619 4.619 0 0 0 2.461 1.63l2.79.743c2.94.792 5.87-1.283 5.87-4.154a5.302 5.302 0 0 0-.181-1.389Z"
        fill={fill ? fill : 'url(#b)'}
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1=".665"
        y1="9.429"
        x2="31.27"
        y2="9.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#259BE9" />
        <stop offset="1" stopColor="#AFDAF7" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h30v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
